(function () {
  function initQuiz(root) {
    if (!root || root.dataset.quizReady === '1') return;
    root.dataset.quizReady = '1';

    var questions = Array.prototype.slice.call(root.querySelectorAll('[data-quiz-question]'));
    var resultEl = root.querySelector('[data-quiz-result]');
    var resultBody = root.querySelector('[data-quiz-result-body]');
    var bar = root.querySelector('[data-quiz-bar]');
    var stepLabel = root.querySelector('[data-quiz-step]');
    var restartBtn = root.querySelector('[data-quiz-restart]');
    var dataEl = root.querySelector('[data-quiz-results]');
    if (!questions.length || !resultEl || !resultBody || !dataEl) return;

    var results = [];
    try {
      results = JSON.parse(dataEl.textContent || '[]');
    } catch (e) {
      results = [];
    }

    var total = questions.length;
    var index = 0;
    var answers = [];

    function updateProgress() {
      var pct = Math.round((index / total) * 100);
      if (bar) bar.style.width = pct + '%';
      if (stepLabel) stepLabel.textContent = Math.min(index + 1, total) + ' / ' + total;
    }

    function show(i) {
      questions.forEach(function (q, qi) {
        q.hidden = qi !== i;
      });
      resultEl.hidden = true;
      index = i;
      updateProgress();
    }

    function pickResult() {
      var counts = {};
      answers.forEach(function (t) {
        if (!t) return;
        counts[t] = (counts[t] || 0) + 1;
      });
      var best = null;
      var bestN = 0;
      Object.keys(counts).forEach(function (k) {
        if (counts[k] > bestN) {
          bestN = counts[k];
          best = k;
        }
      });
      if (!best && answers.length) best = answers[0];
      var match = null;
      for (var i = 0; i < results.length; i++) {
        if (results[i].tag && best && results[i].tag.toLowerCase() === String(best).toLowerCase()) {
          match = results[i];
          break;
        }
      }
      return match || results[0] || null;
    }

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function renderResult() {
      var r = pickResult();
      questions.forEach(function (q) {
        q.hidden = true;
      });
      if (bar) bar.style.width = '100%';
      if (stepLabel) stepLabel.textContent = total + ' / ' + total;

      if (!r) {
        resultBody.innerHTML = '<p>Bir öneri bulunamadı.</p>';
        resultEl.hidden = false;
        return;
      }

      var html = '<div class="frime-quiz__rec">';
      if (r.image) {
        var imgSrc = r.image.indexOf('//') === 0 ? 'https:' + r.image : r.image;
        html +=
          '<img class="frime-quiz__rec-img" src="' +
          esc(imgSrc) +
          '" alt="' +
          esc(r.title) +
          '" width="160" height="160" loading="lazy" decoding="async">';
      }
      html += '<div class="frime-quiz__rec-body">';
      if (r.title) html += '<h3 class="frime-quiz__rec-title">' + esc(r.title) + '</h3>';
      if (r.text) html += '<p class="frime-quiz__rec-text">' + esc(r.text) + '</p>';
      if (r.price) html += '<p class="frime-quiz__rec-price">' + esc(r.price) + '</p>';
      if (r.url) {
        html +=
          '<a class="button button--primary frime-quiz__rec-cta" href="' +
          esc(r.url) +
          '">' +
          esc(r.cta || 'Ürünü incele') +
          '</a>';
      }
      html += '</div></div>';
      resultBody.innerHTML = html;
      resultEl.hidden = false;
    }

    root.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-quiz-option]');
      if (opt && root.contains(opt)) {
        answers[index] = opt.dataset.tag || '';
        if (index + 1 < total) {
          show(index + 1);
        } else {
          renderResult();
        }
        return;
      }

      var back = e.target.closest('[data-quiz-back]');
      if (back && root.contains(back)) {
        if (index > 0) show(index - 1);
        return;
      }

      if (e.target.closest('[data-quiz-restart]')) {
        answers = [];
        show(0);
      }
    });

    if (restartBtn) restartBtn.setAttribute('type', 'button');
    show(0);
  }

  function boot() {
    document.querySelectorAll('[data-quiz]').forEach(initQuiz);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
